// Editorial references to documented public places associated with the artist.
// Puerto Rico is the subject; the artist's contributions are one part of its story.
// Never imply endorsement, ownership or private access without verified evidence.
export const BAD_BUNNY_GUIDE_PATH = "/bad-bunny-puerto-rico";
export const LA_GABRIELA_GUIDE_PATH = "/la-gabriela-rio-piedras";

export const LA_GABRIELA_PLACE = {
  name: "La Gabriela",
  address: "Calle Brumbaugh y Paseo de Diego, Río Piedras, San Juan, Puerto Rico",
  source: "https://www.elnuevodia.com/negocios/bienes-raices/notas/la-gabriela-un-nuevo-proyecto-de-bad-bunny-en-rio-piedras/",
};

export const BAD_BUNNY_STOPS = [
  {
    id: "comunion", area: "Río Piedras · Santurce", name: "Café Comunión",
    titleEs: "Café Comunión — café que viajó con la gira",
    titleEn: "Café Comunión — coffee that went on tour",
    connectionEs: "Sus fundadores llevaron el café de Puerto Rico tras bastidores durante la gira mundial Debí Tirar Más Fotos; cuenta con locales en Río Piedras y Santurce.",
    connectionEn: "Its founders served Puerto Rican coffee backstage on the Debí Tirar Más Fotos world tour; the café has Río Piedras and Santurce locations.",
    address: "51 Calle Brumbaugh, Paseo de Diego, Río Piedras, San Juan, Puerto Rico",
    path: "/cafe-comunion",
    source: "https://www.plateapr.com/que-saber/bad-bunny-cafe-comunion-gira-mundial",
    kindEs: "Cafetería local", kindEn: "Local coffee shop"
  },
  {
    id: "boricua", area: "Río Piedras", name: "El Boricua",
    titleEs: "El Boricua — música y una presentación sorpresa",
    titleEn: "El Boricua — music and a surprise performance",
    connectionEs: "Bad Bunny sorprendió al público con una presentación gratuita frente a este local en enero de 2025.",
    connectionEn: "Bad Bunny surprised crowds with a free performance outside this venue in January 2025.",
    address: "5 Calle Saldaña, Río Piedras, San Juan, Puerto Rico",
    path: "/el-boricua",
    source: "https://www.plateapr.com/que-hacer/lugares-de-puerto-rico-que-definen-a-bad-bunny",
    kindEs: "Música / cultura nocturna", kindEn: "Live music / nightlife culture"
  },
  {
    id: "choliseo", area: "Hato Rey", name: "Coliseo de Puerto Rico",
    titleEs: "El Choliseo — escenario de la residencia de 2025",
    titleEn: "The Choliseo — home of the 2025 residency",
    connectionEs: "El Coliseo José Miguel Agrelot fue sede de la residencia No me quiero ir de aquí en 2025. La residencia ya concluyó; consulta el calendario para eventos futuros.",
    connectionEn: "The José Miguel Agrelot Coliseum hosted the No me quiero ir de aquí residency in 2025. The residency has ended; check the venue for future events.",
    address: "500 Avenida Molyneux, Hato Rey, San Juan, Puerto Rico",
    path: "/coliseo-de-puerto-rico-jose-miguel-agrelot-choliseo",
    source: "https://www.cntraveler.com/story/bad-bunny-puerto-rico-island-residency",
    kindEs: "Recinto de conciertos", kindEn: "Concert venue"
  },
  {
    id: "habitante", area: "Santurce", name: "Habitante Café",
    titleEs: "Habitante Café — una entrevista con Zane Lowe",
    titleEn: "Habitante Café — the Zane Lowe interview",
    connectionEs: "El artista grabó aquí una entrevista con Zane Lowe para Apple Music; el café es un negocio independiente.",
    connectionEn: "The artist sat down here for a Zane Lowe interview for Apple Music; the café is an independent local business.",
    address: "959 Avenida Manuel Fernández Juncos #35, Santurce, San Juan, Puerto Rico",
    source: "https://www.plateapr.com/en/things-to-do/the-puerto-rico-places-that-define-bad-bunny",
    kindEs: "Café / desayuno", kindEn: "Coffee / breakfast"
  },
  {
    id: "casita", area: "Villa Palmeras", name: "La Casita Blanca",
    titleEs: "La Casita Blanca — comida criolla y cultura",
    titleEn: "La Casita Blanca — Puerto Rican home cooking",
    connectionEs: "Se ha documentado a Benito visitando este restaurante tradicional. Es una parada gastronómica por méritos propios.",
    connectionEn: "Reports document Benito visiting this traditional restaurant. It is worth experiencing for its own Puerto Rican cuisine.",
    address: "351 Calle Tapia, Villa Palmeras, San Juan, Puerto Rico",
    source: "https://www.plateapr.com/en/things-to-do/the-puerto-rico-places-that-define-bad-bunny",
    kindEs: "Restaurante criollo", kindEn: "Puerto Rican restaurant"
  },
  {
    id: "placita", area: "Santurce", name: "La Placita de Santurce",
    titleEs: "La Placita — reguetón, noche y arte urbano",
    titleEn: "La Placita — reggaetón, nightlife and street art",
    connectionEs: "El área reúne murales y vida nocturna; se documentó una obra relacionada con Un Verano Sin Ti junto al local Órale. Los murales pueden cambiar.",
    connectionEn: "The neighborhood brings murals and nightlife together; a documented Un Verano Sin Ti mural appeared near Órale. Street art can change.",
    address: "Plaza del Mercado de Santurce, San Juan, Puerto Rico",
    source: "https://www.plateapr.com/en/things-to-do/events-and-hidden-gems-bad-bunny-residency-edition",
    kindEs: "Barrio / arte urbano", kindEn: "Neighborhood / street art"
  },
  {
    id: "vega", area: "Vega Baja", name: "Mural de Bad Bunny en Vega Baja",
    titleEs: "Vega Baja — homenaje en su pueblo",
    titleEn: "Vega Baja — a hometown mural",
    connectionEs: "Un mural público junto a Atelier Coworking celebra al artista y a otras figuras de Vega Baja. Es preferible visitar obras públicas a buscar direcciones privadas.",
    connectionEn: "A public mural by Atelier Coworking honors the artist alongside other Vega Baja figures. Public artwork is a better stop than private addresses.",
    address: "Atelier Coworking Space, Vega Baja, Puerto Rico",
    source: "https://www.elnuevodia.com/negocios/empresas-comercios/notas/abre-sus-puertas-atelier-co-working-space-sobre-mural-de-bad-bunny-en-vega-baja/",
    kindEs: "Arte público / pueblo natal", kindEn: "Public art / hometown"
  },
];

export const LA_GABRIELA_FAQ = [
  {
    qEs: "¿Dónde está La Gabriela en Río Piedras?", qEn: "Where is La Gabriela in Río Piedras?",
    aEs: "La fachada identificada como La Gabriela está en la esquina del Paseo de Diego y la calle Brumbaugh, Río Piedras, San Juan.",
    aEn: "The building with the La Gabriela sign is at Paseo de Diego and Brumbaugh Street in Río Piedras, San Juan."
  },
  {
    qEs: "¿Qué se sabe de La Gabriela?", qEn: "What has been confirmed about La Gabriela?",
    aEs: "Se ha documentado la remodelación del edificio y su letrero. No se ha verificado públicamente una fecha de apertura ni el uso comercial definitivo del espacio.",
    aEn: "The building renovation and signage have been documented. A public opening date and its eventual business use have not been verified."
  },
  {
    qEs: "¿Se puede visitar La Gabriela?", qEn: "Can you visit La Gabriela?",
    aEs: "La fachada se puede observar desde espacios públicos. No se ha confirmado acceso al interior ni horarios de atención.",
    aEn: "The exterior can be seen from public space. Interior access and opening hours have not been confirmed."
  },
];

export const BAD_BUNNY_FAQ = [
  {
    qEs: "¿Cómo ha contribuido Bad Bunny a Puerto Rico?", qEn: "How has Bad Bunny contributed to Puerto Rico?",
    aEs: "Ha llevado la música y las referencias culturales puertorriqueñas a escenarios internacionales. Su residencia de 2025 generó actividad económica y la Fundación Good Bunny apoya oportunidades artísticas, deportivas y educativas para jóvenes.",
    aEn: "He has brought Puerto Rican music and cultural references to international audiences. His 2025 residency stimulated local economic activity, and the Good Bunny Foundation supports arts, sports and educational opportunities for young people."
  },
  {
    qEs: "¿Qué es la Fundación Good Bunny?", qEn: "What is the Good Bunny Foundation?",
    aEs: "Una entidad sin fines de lucro fundada en 2018 que desarrolla proyectos para jóvenes de Puerto Rico en música, artes y deportes.",
    aEn: "A nonprofit founded in 2018 that supports young people in Puerto Rico through music, arts and sports projects."
  },
  {
    qEs: "¿Esta guía describe lugares que pertenecen a Bad Bunny?", qEn: "Does this guide list places owned by Bad Bunny?",
    aEs: "No. Presenta lugares públicos con conexiones documentadas y negocios independientes; una visita, actuación o referencia cultural no implica propiedad ni patrocinio.",
    aEn: "No. It features public places with documented connections and independent businesses. A visit, performance or cultural reference does not imply ownership or sponsorship."
  },
  {
    qEs: "¿Sigue la residencia de Bad Bunny en Puerto Rico?", qEn: "Is Bad Bunny's Puerto Rico residency still running?",
    aEs: "No. Su residencia en el Coliseo de Puerto Rico se celebró en 2025. Verifica fuentes oficiales para futuras fechas.",
    aEn: "No. His Coliseo de Puerto Rico residency took place in 2025. Check official sources for any future dates."
  },
  {
    qEs: "¿Qué lugares públicos relacionados con Bad Bunny puedo visitar?", qEn: "What public Bad Bunny-related sites can I visit?",
    aEs: "Algunas opciones documentadas son El Boricua, Café Comunión, el Choliseo, La Placita de Santurce y obras de arte público en Vega Baja.",
    aEn: "Documented options include El Boricua, Café Comunión, the Choliseo, La Placita de Santurce and public art in Vega Baja."
  },
  {
    qEs: "¿Esta guía es oficial o patrocinada por Bad Bunny?", qEn: "Is this an official or Bad Bunny-sponsored guide?",
    aEs: "No. Es una guía editorial independiente de Ya Tú Sabes PR. Los vínculos, lugares y referencias se identifican con sus fuentes.",
    aEn: "No. This is an independent editorial guide from Ya Tú Sabes PR. Connections and locations are documented with sources."
  },
];
